
export const getSystemStatus = async (restAPI) => {
  return await restAPI.get("/system");
}